export default "__VITE_ASSET___gw3nA4E__"